module.exports = __webpack_public_path__ + "static/logo-laboratorio-c77d1701ce2fbbc2a0ab47afe412c214.svg";